import { APP_COLOR } from "../../theme";

export const styles = {
  progressContainer: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  } as const,
  customLinearProgress: {
    display: "flex",
    alignItems: "center"
  } as const,
  linearProgressContainer: {
    width: "100%",
    mr: 1,
    color: APP_COLOR
  } as const,
};
